export const MAINTENANCE_MODE = 'pAAR2945PayexMaintenanceMode';
export const CAMELIZED_FEATURES = [MAINTENANCE_MODE] as const;
export const ENABLE_FEATURE = 'ENABLE_FEATURE';
export const FETCH_FEATURES_REQUEST = 'FETCH_FEATURES_REQUEST';
export const FETCH_FEATURES_SUCCESS = 'FETCH_FEATURES_SUCCESS';
export const FETCH_FEATURES_ERROR = 'FETCH_FEATURES_ERROR';
export const FF_HOLIDAY_BANNER_CN = 'PAAR-5353-holidayBannerCN';
export const FF_HOLIDAY_BANNER_IN = 'PAAR-6343-holidayBannerIN';
export const FF_HOLIDAY_BANNER_KR = 'PAAR-6781-holidayBannerKR';
export const FF_HOLIDAY_BANNER_VN = 'PAAR-5353-holidayBannerVN';
export const FF_HOLIDAY_BANNER_NP = 'PAAR-6809-holidayBannerNP';
export const FF_CAPTCHA = 'PAAR-4218-VerifyTokenInBackend';
export const FF_PAYING_FROM_INDIA_IN_USD = 'PAAR-5643-Mario';
export const FF_BANNER_COUPONS_CN = 'REM-1374-bannerCouponsCN';
export const FF_HIDE_KYC_BUTTON = 'PAAR-5826-hideKycButton';
export const FF_ACADEMIC_FIELDS = 'REM-1508-AcademicFields';
export const FF_MANDATORY_ACCOUNT_INDIA = 'LOOP-1399-MandatoryAccountIndia';
export const FF_MANDATORY_ACCOUNT_INDIA_VERSION =
  'LOOP-1399-MandatoryAccountIndiaVersion';
export const FF_MANDATORY_ACCOUNT_CHINA = 'LOOP-1527-MandatoryAccountChina';
export const FF_MANDATORY_ACCOUNT_CHINA_VERSION =
  'LOOP-1527-MandatoryAccountChinaVersion';
export const FF_NEW_INDIAN_WIZARD = 'PAAR-6332';
export const FF_HIDE_BPG_BANNER = 'PAAR-6586-HideBPGBanner';

export const DISABLE_OLD_COOKIES_BANNER = 'pAAR5317DisableOldCookiesBanner';
export const FF_OLD_COOKIES_BANNER_DISABLED =
  'PAAR-5317-DisableOldCookiesBanner';

export const TURKISH_LANGUAGE = 'pAAR6462TurkishLanguage';
export const FF_TURKISH_LANGUAGE = 'PAAR-6462-TurkishLanguage';
export const FF_REWARDS_CHINA = 'LOOP-2017-RewardsChina';
export const FF_SURCHARGE_FLOW_V2 = 'PAAR-6428-SurchargeFlowV2';
export const FF_CARD_ELEMENT_FLOW = 'PAAR-6964-CardElementFlow';

export const FEATURES = [
  'PAAR-2945-payex_maintenance_mode',
  FF_HOLIDAY_BANNER_CN,
  FF_HOLIDAY_BANNER_IN,
  FF_HOLIDAY_BANNER_KR,
  FF_HOLIDAY_BANNER_VN,
  FF_HOLIDAY_BANNER_NP,
  FF_PAYING_FROM_INDIA_IN_USD,
  FF_BANNER_COUPONS_CN,
  FF_HIDE_KYC_BUTTON,
  FF_ACADEMIC_FIELDS,
  FF_OLD_COOKIES_BANNER_DISABLED,
  FF_TURKISH_LANGUAGE,
  FF_REWARDS_CHINA,
  FF_SURCHARGE_FLOW_V2,
] as const;

const FEATURE_TYPES = [FF_CAPTCHA] as const;

export type FeatureFlag =
  | (typeof FEATURES)[number]
  | (typeof FEATURE_TYPES)[number];
